exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".keyword-category[data-v-36ddac93]{cursor:pointer;border-bottom:1px solid #fff}.keyword-category.active[data-v-36ddac93],.keyword-category[data-v-36ddac93]:hover{background-color:#eff2f7}.keyword-category .chevron-right[data-v-36ddac93]{float:right;display:none}.keyword-category.active .chevron-right[data-v-36ddac93]{display:block;position:relative;top:1px}.use-keyword-assistant[data-v-36ddac93]{color:#74788d}.keyword-icon[data-v-36ddac93]{font-size:16px;line-height:16px;position:absolute;top:1px;left:1px;height:19px}", ""]);

// exports
